// src/activity/dto/list-activities.dto.ts
import {
  IsOptional,
  IsUUID,
  IsIn,
  IsString,
  IsBoolean,
  IsArray,
} from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { ActivityVisibility } from '../../../enums'

export class ListActivitiesDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    type: 'string',
    description: "Filtrer par titre d'activité",
  })
  @IsOptional()
  @IsString()
  titleActivity?: string

  @ApiPropertyOptional({
    type: 'string',
    description: "Filtrer par ID de type d'activité",
  })
  @IsOptional()
  @IsUUID('4')
  activityTypeId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par Activité exercice',
  })
  @IsOptional()
  @IsBoolean()
  isExercice?: boolean

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par State',
  })
  @IsOptional()
  @IsUUID('4')
  stateId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par visibilité',
    enum: ActivityVisibility,
  })
  @IsOptional()
  @IsIn(['PRIVATE', 'CLASS', 'ESTABLISHMENT', 'PUBLIC'])
  visibility?: 'PRIVATE' | 'CLASS' | 'ESTABLISHMENT' | 'PUBLIC'

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par établissement',
  })
  @IsOptional()
  @IsString()
  establishmentId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par Autorité utilisateur',
  })
  @IsOptional()
  @IsUUID('4')
  authorUserId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par Kind',
  })
  @IsOptional()
  @IsUUID('4')
  kindId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par Subject',
  })
  @IsOptional()
  @IsUUID('4')
  subjectId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par niveau (ClassLevelExternalRef)',
  })
  @IsOptional()
  @IsUUID('4')
  classLevelExternalId?: string

  @ApiPropertyOptional({
    description: "Filtrer par ID d'état",
  })
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  tags?: string

  @ApiPropertyOptional({
    description: 'Filtrer par Activité réalisable au jour actuel',
  })
  @IsOptional()
  @IsBoolean()
  isRealizable?: boolean

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par ID de leçon',
  })
  @IsOptional()
  @IsUUID('4')
  lessonId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par ID de classe',
  })
  @IsOptional()
  @IsUUID('4')
  teachingId?: string
}
